import { Grid, LinearProgress, Typography } from "@material-ui/core"
import { Pagination } from "@material-ui/lab";

import React from "react";
import { usePretWriterQueue } from "../projectManagementQueries";
import { PreWritterTable } from "./PreWitterTable";
import { useQueryClient } from "react-query";


export const PreWritterQueuePage = () => {

    const [page, setPage] = React.useState(1);
    const itemsPerPage = 10;
    const [action, setAction] = React.useState(1);
    const queryClient = useQueryClient();


    const {
        data: writerdata,
        isLoading: isLoadingWriterReports,
        isError,
        error,
        refetch,
    } = usePretWriterQueue(page == 1 ? 0 : (page - 1) * 10, itemsPerPage, action);

      if (isLoadingWriterReports) {
        return <LinearProgress />;
      }


    return (
        <div>
            <Typography variant="h2">Pre Writer's Queue</Typography>


            <Grid item xs={12} style={{ marginTop:"30px", marginBottom: "20px" }}>
                <Pagination
                    count={Math.ceil(writerdata.count / itemsPerPage)}
                    page={page}
                    onChange={(event, value) => {
                        console.log('Changing page to:', value);
                        setPage(value);
                        queryClient.invalidateQueries(['pre_Writer_data']);
                    }}
                    variant="outlined"
                    color="primary"
                />
            </Grid>


            {writerdata && (
                <PreWritterTable data={writerdata} refetch={refetch} />
            )}

            <Grid item xs={12} style={{ marginTop: "20px" }}>
                <Pagination
                    count={Math.ceil(writerdata.count / itemsPerPage)}
                    page={page}
                    onChange={(event, value) => {
                        console.log('Changing page to:', value);
                        setPage(value);
                        queryClient.invalidateQueries(['pre_Writer_data']);
                    }}
                    variant="outlined"
                    color="primary"
                />
            </Grid>
        </div>
    )
}